// material-ui
// import { Theme } from '@mui/material/styles';
// import { useMediaQuery  } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => {
  // const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return <></>;
};

export default AuthFooter;
